import { forecastTotal, type ForecastResult, type MonthlyAggregate } from "@vunora/forecasting";

export type ForecastHorizon = "month" | "quarter";

export const ILLUSTRATIVE_HISTORY: MonthlyAggregate[] = [
  { month: "2026-01", total: 46_800, categories: { Home: 24_000, Food: 9_300, Travel: 4_400, Other: 9_100 } },
  { month: "2026-02", total: 48_200, categories: { Home: 24_000, Food: 9_700, Travel: 5_100, Other: 9_400 } },
  { month: "2026-03", total: 45_100, categories: { Home: 24_000, Food: 8_900, Travel: 4_000, Other: 8_200 } },
  { month: "2026-04", total: 49_700, categories: { Home: 24_000, Food: 9_600, Travel: 5_300, Other: 10_800 } },
  { month: "2026-05", total: 47_500, categories: { Home: 24_000, Food: 9_500, Travel: 4_700, Other: 9_300 } },
  { month: "2026-06", total: 51_200, categories: { Home: 24_000, Food: 9_800, Travel: 5_200, Other: 12_200 } },
];

export interface ForecastDriver {
  id: string;
  label: string;
  amount: number;
  explanation: string;
}

export interface ForecastView {
  horizon: ForecastHorizon;
  label: "Next month" | "Quarter";
  monthsAhead: 1 | 3;
  result: ForecastResult;
  history: MonthlyAggregate[];
  drivers: ForecastDriver[];
}

const DRIVERS: ForecastDriver[] = [
  {
    id: "rent",
    label: "Rent pattern",
    amount: 24_000,
    explanation: "A regular month-start expense anchors the lower part of the range.",
  },
  {
    id: "card",
    label: "Card bill due",
    amount: 11_400,
    explanation: "Recent card activity lifts the upper side of the illustrative range.",
  },
  {
    id: "groceries",
    label: "Grocery trend",
    amount: 9_800,
    explanation: "The latest food pattern is included as a named, inspectable driver.",
  },
];

export function buildForecastView(horizon: ForecastHorizon): ForecastView {
  const monthsAhead = horizon === "quarter" ? 3 : 1;
  return {
    horizon,
    label: horizon === "quarter" ? "Quarter" : "Next month",
    monthsAhead,
    result: forecastTotal({ history: ILLUSTRATIVE_HISTORY, monthsAhead }),
    history: ILLUSTRATIVE_HISTORY,
    drivers: DRIVERS.map((driver) => ({
      ...driver,
      amount: driver.amount * monthsAhead,
    })),
  };
}

export function formatRupees(value: number): string {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(value);
}
